import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../state/actions";
import ReactTooltip from "react-tooltip";
import Briciole from "../../shared/briciole/Briciole";
import BarraCheckout from "../barraCheckout/BarraCheckout";
import CheckboxField from "../../shared/checkboxField/CheckboxField";
import TextareaField from "../../shared/textareaField/TextareaField";
import CustomButton from "../../shared/customButton/CustomButton";
import ModalConfirm from "../../shared/modalConfirm/ModalConfirm";
import LazyLoadImg from "../../shared/lazyLoadImg/LazyLoadImg";
import RiepilogoCarrello from "../riepilogoCarrello/RiepilogoCarrello";
import CartRow from "./cartRow/CartRow";
import debounce from "../../../utils/debounce";
import { gtmRemoveFromCart, gtmViewCart } from "../../../gtm/gtm";

const CartDetail = () => {
  const dispatch = useDispatch();
  const currentPage = useSelector((state) => state.currentPage);
  const tokenCarrello = useSelector((state) => state.user.token_id);
  const isUserLogged = useSelector((state) => state.user.isLogged);
  const user = useSelector((state) => state.user);
  const order = useSelector((state) => state.order);
  const siteParams = useSelector((state) => state.siteParams);
  const cart = useSelector((state) => state.cart);
  const promotion = useSelector((state) => state.promotion);
  const campiFormTranslation = useSelector(
    (state) => state.translations.campiFormRegistrazione
  );
  const carrelloTranslation = useSelector(
    (state) => state.translations.carrello
  );
  const mainNavigation = useSelector(
    (state) => state.translations.mainNavigation
  );
  const genericheTranslation = useSelector(
    (state) => state.translations.generiche
  );

  // local state
  const [isSelectedRows, setIsSelectedRows] = useState(false);
  const [itemsToDelete, setItemsToDelete] = useState([]);
  const [note, setNote] = useState(order?.notes);
  const [showWarning, setShowWarning] = useState(false);
  const [showOmaggio, setshowOmaggio] = useState(false);
  const [myAmbassadorCode, setMyAmbassadorCode] = useState(null);

  useEffect(() => {
    console.log("ambassadorCode", myAmbassadorCode);
    if (user?.userData?.my_ambassador_code !== undefined) {
      setMyAmbassadorCode(user?.userData?.my_ambassador_code);
    }

    /**
     * GTM CHECKOUT LOGIN REGISTRAZIONE - STEP 1
     */
    const gtmSuffix = `gtm_code${currentPage.currentLang}`;
    const currentGTMTAG = siteParams[gtmSuffix];
    gtmViewCart({
      cartData: cart,
      orderData: order,
      isGtmEnabled: currentGTMTAG !== null ? true : false,
    });
  }, [
    isSelectedRows,
    itemsToDelete,
    showWarning,
    showOmaggio,
    soglia_omaggio,
    myAmbassadorCode,
    user,
  ]);

  const onSelectCartRow = (cart_id, isSelectedRow) => {
    /* console.log('ho chiamato onSelectCartRow', [cart_id, isSelectedRow]); */
  };

  const onChangeNote = debounce(function (event) {
    setNote(event.target.value);

    // chiamo action creator per aggiornare store con le note
    dispatch(
      allActions.cartDetailActions.updateNotes(
        currentPage.currentLang,
        user?.userData?.id,
        tokenCarrello,
        event.target.value
      )
    );
  }, 2000);

  const onSelectCartRows = () => {
    // rimuovo aggiungo tutte le righe
    setIsSelectedRows(!isSelectedRows);

    //console.log('onSelectCartRows', isSelectedRows);

    // aggiorno stato locale
    const array_selected_rows = Object.keys(cart).map((cartIndex) => {
      return cart[cartIndex].id;
    });
    if (isSelectedRows === false) {
      // aggiungo tutti gli id
      setItemsToDelete(array_selected_rows);
    } else {
      // rimuovo tutti
      setItemsToDelete([]);
    }

    //console.log('array_selected_rows', array_selected_rows);
  };

  const onAskDeleteCartItems = () => {
    if (order.totalItems === 0) return;

    if (itemsToDelete.length > 0) {
      ModalConfirm({
        titleToShow: carrelloTranslation.modalTitoloRimozioneArticoli.itemName,
        messageToShow:
          carrelloTranslation.modalConfermaRimozioneArticoli.itemName,
        textConfirmButton: genericheTranslation.conferma.itemName,
        textCancelButton: genericheTranslation.annulla.itemName,
        onClickHandler: () => onDeleteCartItems(),
      });
    } else {
      ModalConfirm({
        titleToShow: carrelloTranslation.modalTitoloRimozioneArticoli.itemName,
        messageToShow:
          carrelloTranslation.modalErroreRimozioneArticoli.itemName,
        isShowConfirmButton: false,
        isShowCanceButton: false,
        isTimerModal: true,
        textConfirmButton: genericheTranslation.conferma.itemName,
        textCancelButton: genericheTranslation.annulla.itemName,
      });
    }
  };

  const onDeleteCartItems = () => {
    // gtm remove all items from cart
    // loop cart
    const totalElements = Object.keys(cart).length;
    Object.keys(cart).map((itemId, index) => {
      const cartElement = cart[itemId];
      console.log(cartElement);
      gtmRemoveFromCart({
        productData: {
          titoloBreve: cartElement.name,
          codice: cartElement.attributes.codiceProdotto,
        },
        categoryName: cartElement.attributes.titoloCategoria,
        prezzoCarrello: cartElement.price,
        quantitaCarrello: cartElement.quantity,
        callbackFunction: () => onGoToDeleteCartItems(index, totalElements),
      });
    });
  };

  const onGoToDeleteCartItems = (index, totalElementsToDelete) => {
    console.log(index, totalElementsToDelete);
    if (index + 1 <= totalElementsToDelete) {
      // chiamo action creator per aggiornare store
      dispatch(
        allActions.cartDetailActions.deleteCartItems(
          currentPage.currentLang,
          user?.userData?.id,
          tokenCarrello
        )
      );
    }
  };

  // warning avviso spese di spedizione all'estero calcolate successivamente perchè non c'è un valore
  const warningAlertHandler = ($mostra = false) => {
    setShowWarning($mostra);
  };

  // variabili per kit
  let currentKitGroup = null;
  let showHeaderKit = false;

  const cartRows = Object.keys(cart).map((cartIndex, index, cartArray) => {
    const cartRow = cart[cartIndex];
    const cartNextRowKey = cartArray[index + 1];
    const cartNextRow = cart[cartNextRowKey];
    const isNextElementAccessory = cartNextRow?.attributes?.kit_accessory;

    // controllo se è presente un kit ed al primo elemento che trovo aggiungo una voce in più per mostrare l'header del kit
    if (
      cartRow.attributes?.kit_data === undefined ||
      cartRow.attributes?.kit_data === null
    ) {
      currentKitGroup = null;
      showHeaderKit = false;
    } else {
      if (showHeaderKit === false && currentKitGroup === null) {
        showHeaderKit = true;
      } else {
        showHeaderKit = false;
      }
      if (currentKitGroup === null) {
        currentKitGroup = cartRow.attributes.kit_data;
      }
    }

    return (
      <CartRow
        key={cartIndex}
        idProdotto={cartRow.id}
        nomeProdotto={cartRow.name}
        titoloCategoria={cartRow.attributes.titoloCategoria}
        codiceProdotto={cartRow.attributes.codiceProdotto}
        dimensioni={cartRow.attributes.dimensione}
        unitaMisura={cartRow.attributes.unitaMisura}
        lunghezza={cartRow.attributes.lunghezza}
        larghezza={cartRow.attributes.larghezza}
        profondita={cartRow.attributes.profondita}
        metrilineari={cartRow.attributes.metrilineari}
        diametro={cartRow.attributes.diametro}
        colore={cartRow.attributes.colore}
        opzioneId={cartRow.attributes.opzioneId}
        opzioneName={cartRow.attributes.opzioneName}
        prezzoFisso={cartRow.attributes.prezzoFisso}
        isomaggio={cartRow.attributes?.isomaggio}
        prontaConsegna={cartRow.attributes.prontaConsegna}
        giacenza={cartRow.attributes.giacenza}
        peso={cartRow.attributes.pesoCollo}
        quantita={cartRow.quantity}
        quantitaPrezzoFisso={cartRow.attributes?.quantitaPrezzoFisso}
        imponibile={cartRow.price}
        imponibileOriginale={cartRow.attributes.imponibileOriginale}
        flag_abilita_quantita_fissa={
          cartRow.attributes?.flag_abilita_quantita_fissa
        }
        totale={cartRow.price * cartRow.quantity}
        totaleOriginale={
          cartRow.attributes.imponibileOriginale * cartRow.quantity
        }
        immagine={cartRow.attributes.immagine}
        isKit={showHeaderKit}
        isKitNotEmpty={isNextElementAccessory}
        isKitManodopera={cartRow.attributes?.is_kit_manodopera}
        kit_product_related_id={cartRow.attributes?.kit_product_related_id}
        kit_product_cart_id={cartRow.attributes?.kit_product_cart_id}
        kit_data={cartRow.attributes?.kit_data}
        isCheckedRows={isSelectedRows}
        onSelectRowFunction={onSelectCartRow}
      />
    );
  });

  const messageNoItems =
    order.totalItems === 0 ? (
      <div className="flex justify-center py-8 text-xl font-opensansbold">
        {carrelloTranslation.messaggioCarrelloVuoto.itemName}
      </div>
    ) : (
      ""
    );

  // controllo promozione a tempo spedizione gratuita sopra soglia (mostro banner)
  const showTrasportoGratuito = promotion?.sogliaCarrello !== undefined &&
    order.totalItems > 0 && (
      <div className="w-full relative flex items-center bg-ribola-chelsea-cucumber text-white text-sm sm:text-base mt-8 px-6 py-3">
        <i className="fal fa-shipping-timed text-2xl mr-6"></i>
        <span className="flex flex-col justify-center">
          <span>
            {genericheTranslation.superatii.itemName.toUpperCase()}
            <b className="text-xl mx-2">{promotion.sogliaCarrello} €</b>
            {genericheTranslation.spedizionegratuita.itemName.toUpperCase()}
          </span>
          <span className="text-sm">
            {genericheTranslation.promozioneatempovalida.itemName}
            &nbsp;
            {genericheTranslation.dal.itemName}&nbsp;
            <strong>{promotion.dataDa}</strong>{" "}
            {genericheTranslation.al.itemName}
            &nbsp;
            <strong>{promotion.dataA}</strong>
          </span>
        </span>
      </div>
    );

  // mostro alert warning se necessario
  const showAlertWarning = showWarning && (
    <div className="w-full relative flex items-center bg-yellow-500 text-white text-sm sm:text-base mt-8 px-6 py-3">
      <i className="fal fa-brake-warning text-2xl mr-6"></i>
      <span>{genericheTranslation.spesetrasportocalcolate.itemName}</span>
    </div>
  );

  const soglia_omaggio = parseFloat(siteParams?.soglia_omaggio);
  const immagine_omaggio = siteParams?.immagine_omaggio;
  const product_id_omaggio = siteParams?.product_id_omaggio;

  // mostro alert warning se necessario
  // 20230918: non mostro warning se product_id_omaggio non definito
  const showOmaggioInfo =
    soglia_omaggio !== undefined &&
    product_id_omaggio !== undefined &&
    (user?.userData?.meta_data?.partitaiva === undefined ||
      user?.userData?.meta_data?.partitaiva == "" ||
      user?.userData?.meta_data?.partitaiva === null ||
      !isUserLogged) &&
    !isNaN(soglia_omaggio) ? (
      order.subtotalCart < soglia_omaggio ? (
        <div className="w-full relative flex items-center bg-yellow-500 text-white text-sm sm:text-base mt-8 px-6 py-3">
          <i className="fal fa-brake-warning text-2xl mr-6"></i>
          <span>
            {genericheTranslation.avvisoomaggiocarrello1.itemName.replace(
              "XXX",
              (soglia_omaggio - order.subtotalCart).toFixed(2)
            )}
          </span>
        </div>
      ) : (
        <div className="w-full relative flex items-center bg-green-600 text-white text-sm sm:text-base mt-8 px-6 py-3">
          <i className="fal fa-thumbs-up text-2xl mr-6"></i>
          <span>
            {genericheTranslation.avvisoomaggiocarrello2.itemName.replace(
              "YYY",
              soglia_omaggio.toFixed(2)
            )}
          </span>
        </div>
      )
    ) : (
      ""
    );

  const soglia_ambassador = parseFloat(siteParams?.soglia_ambassador);
  const credito_ambassador = parseFloat(siteParams?.credito_ambassador);
  const fascia_acquisto_ambassador = parseFloat(
    siteParams?.fascia_acquisto_ambassador
  );
  const fascia_credito_ambassador = parseFloat(
    siteParams?.fascia_credito_ambassador
  );

  // mostro alert warning se necessario
  const showAmbassadorInfo =
    soglia_ambassador !== undefined &&
    !isNaN(soglia_ambassador) &&
    myAmbassadorCode == null &&
    (user?.userData?.meta_data?.partitaiva === undefined ||
      user?.userData?.meta_data?.partitaiva == "" ||
      user?.userData?.meta_data?.partitaiva === null ||
      !isUserLogged) ? (
      order.subtotalCart < soglia_ambassador ? (
        <div className="w-full relative flex items-center bg-yellow-500 text-white text-sm sm:text-base mt-8 px-6 py-3">
          <i className="fal fa-brake-warning text-2xl mr-6"></i>
          <span>
            {genericheTranslation?.avvisoambassadorcarrello1.itemName.replace(
              "XXX",
              (soglia_ambassador - order.subtotalCart).toFixed(2)
            )}
          </span>
        </div>
      ) : (
        <div className="w-full relative flex items-center bg-green-600 text-white text-sm sm:text-base mt-8 px-6 py-3">
          <i className="fal fa-award text-2xl mr-6"></i>
          <span>
            {genericheTranslation?.avvisoambassadorcarrello2.itemName.replace(
              "YYY",
              soglia_ambassador.toFixed(2)
            )}
          </span>
        </div>
      )
    ) : (
      ""
    );

  const showImmagineOmaggio =
    immagine_omaggio !== undefined ? (
      <div className="col-span-60 md:col-span-30 flex flex-col justify-between pl-0 md:pl-8 pb-6 mb-4 xl:mb-0">
        <LazyLoadImg
          imgName={immagine_omaggio?.file_name}
          imgPath={immagine_omaggio?.id}
          imgWidth="640"
          imgHeight="480"
          imgStyle="flex-start"
          imgAlt={immagine_omaggio?.file_name}
        />
      </div>
    ) : (
      ""
    );

  // mostra note ordine solo se ci sono prodotti a carrello
  const showNotes = order.totalItems > 0 && (
    <div className="grid grid-cols-60 mt-6 items-start">
      <div className="col-span-60 md:col-span-30 flex flex-col justify-between bg-ribola-gallery-gray text-black px-8 py-6 mb-4 xl:mb-0">
        <TextareaField
          textareaName="note"
          textareaValue={note}
          textareaPlaceholder={
            campiFormTranslation.inserirenoterelativeordine.itemName
          }
          textareaRows={6}
          textareaHandlerFunction={(event) => onChangeNote(event)}
          textareaStyle="border-none bg-white resize-none w-full p-3"
        />
      </div>
      {showImmagineOmaggio}
    </div>
  );

  return (
    <div className="col-start-3 4xl:col-start-5 col-end-59 4xl:col-end-57 pb-12">
      <Briciole />
      <BarraCheckout currentCheckoutPage={currentPage.routeName} />
      <form>
        <div className="grid grid-cols-60 mt-20">
          <div className="col-start-1 col-end-61 xl:col-end-45">
            <div className="grid grid-cols-60 font-opensansbold text-ribola-tundora border-b border-ribola-dove-gray pb-2">
              <div className="col-span-6 sm:col-span-3 flex justify-center items-center text-red-700">
                <i
                  className="fal fa-trash-alt text-2xl cursor-pointer"
                  data-tip={
                    carrelloTranslation.tooltipCancellaArticoli.itemName
                  }
                  data-for={`123_cancellaTutti`}
                  onClick={onAskDeleteCartItems}
                ></i>
                <ReactTooltip
                  uuid={`123_cancellaTutti`}
                  id={`123_cancellaTutti`}
                  className="px-1 py-0.5 bg-black text-white"
                />
              </div>
              <div
                className="col-span-6 flex justify-between items-center"
                data-tip={carrelloTranslation.tooltipSelezionaArticoli.itemName}
                data-for={`123_selezionaTutti`}
              >
                <CheckboxField
                  checkboxType="checkbox"
                  checkboxName="selectAllCartRows"
                  checkboxHandlerFunction={onSelectCartRows}
                  isChecked={isSelectedRows}
                  isFocus={false}
                  isDefaultChecked={false}
                  checkboxStyle="border-2 text-2xl text-ribola-dove-gray border-ribola-dove-gray cursor-pointer"
                />
                <ReactTooltip
                  uuid={`123_selezionaTutti`}
                  id={`123_selezionaTutti`}
                  className="px-1 py-0.5 bg-black text-white"
                />
              </div>
              <div className="col-span-33 sm:col-span-36 xl:col-span-23 text-sm sm:text-base flex items-center">
                <span>
                  {carrelloTranslation.thProdotto.itemName.toUpperCase()}
                </span>
              </div>
              <div className="col-span-7 items-center hidden xl:flex">
                <span>
                  {carrelloTranslation.thCodice.itemName.toUpperCase()}
                </span>
              </div>
              <div className="col-span-15 xl:col-span-7 text-sm sm:text-base flex items-center">
                <span>
                  {carrelloTranslation.thQuantita.itemName.toUpperCase()}
                </span>
              </div>
              <div className="col-span-7 items-center hidden xl:flex">
                <span>
                  {carrelloTranslation.thImponibile.itemName.toUpperCase()}
                </span>
              </div>
              <div className="col-span-7 items-center hidden xl:flex">
                <span>
                  {carrelloTranslation.thTotale.itemName.toUpperCase()}
                </span>
              </div>
            </div>
            {cartRows}
            {messageNoItems}
            {showTrasportoGratuito}
            {showAlertWarning}
            {showOmaggioInfo}
            {showAmbassadorInfo}
            {showNotes}
            <div className="flex justify-end">
              <CustomButton
                buttonLink={mainNavigation.prodotti.itemLink}
                buttonRouteName={mainNavigation.prodotti.itemRouteName}
                buttonName={`${carrelloTranslation.pulsanteAggiungiAltriProdotti.itemName.toUpperCase()} <i class="far fa-plus ml-3"></i>`}
                buttonStyle="w-full md:w-6/12 xl:w-5/12 3xl:w-5/12 flex justify-center items-center text-white bg-ribola-nobel hover:bg-ribola-dove-gray text-center transition duration-300 sm:text-lg 4xl:text-xl font-opensanssemibold mt-8 mb-8 py-4 px-6 border-r-2 border-ribola-gallery-gray"
              />
            </div>
          </div>
          <div className="col-start-1 col-end-61 xl:col-start-46 xl:col-end-61 bg-ribola-gallery-gray py-8 3xl:py-12 px-6 3xl:px-8">
            <RiepilogoCarrello toggleWarningAlert={warningAlertHandler} />
          </div>
        </div>
      </form>
    </div>
  );
};

export default CartDetail;
